import { render, staticRenderFns } from "./DocumentSeriesTypeListToolbar.vue?vue&type=template&id=1a3e327d&"
import script from "./DocumentSeriesTypeListToolbar.vue?vue&type=script&lang=js&"
export * from "./DocumentSeriesTypeListToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports